import React from "react";
import PropTypes from "prop-types";
import styles from "./style.module.scss";
import { injectIntl, FormattedMessage } from "react-intl";

/**
 * ImageTableBase Component
 *
 * This React component is designed to display a collection of images
 * in a structured table-like format. Each item in the table consists of a heading
 * and an associated image. The data to populate this table is passed as a
 * "content" prop to the component. The content prop is an array where each
 * item should have a 'heading', 'image', and 'alt' property.
 *
 * Usage:
 * <ImageTableBase
 *    content={[
 *        { heading: "Example", image: "path/to/image.jpg", alt: "Description" },
 *        ...
 *    ]}
 * />
 *
 * Props:
 * - content (Array): The data to populate the table. Each item in the array
 *   should be an object with the following structure:
 *   {
 *     heading: String,  // The title/heading of the item
 *     image: String,    // The URL of the associated image
 *     alt: String       // The alt text for the image, used for accessibility
 *   }
 */
class ImageTableBase extends React.Component {
  render() {
    const { intl } = this.props;
    return (
      <div className={styles.Table} dir="auto">
        {this.props.content.map((item) => (
          <div className={styles.Item} key={item.heading}>
            <span className={styles.TableHeading}>
              <FormattedMessage
                id={item.heading}
                defaultMessage={item.heading}
              />
            </span>
            <div className={styles.TableImage}>
              <img
                src={item.image}
                alt={intl.formatMessage({
                  id: item.alt,
                  defaultMessage: item.alt,
                })}
              />
            </div>
          </div>
        ))}
      </div>
    );
  }
}

// Define the expected props for the component
ImageTableBase.propTypes = {
  content: PropTypes.arrayOf(
    PropTypes.shape({
      heading: PropTypes.string.isRequired,
      image: PropTypes.string.isRequired,
      alt: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export const ImageTable = injectIntl(ImageTableBase);
